import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1744a511"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "xitongchushisheding"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "系统初始设定")], -1));

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  class: "title"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("分类：");

const _hoisted_7 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("彩票：");

const _hoisted_9 = {
  class: "redcolor"
};
const _hoisted_10 = {
  class: "theme-border topbox"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "自动降赔设定：", -1));

const _hoisted_12 = /*#__PURE__*/_createTextVNode("启用");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("禁用");

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "同路“号码”随大路降赔率比例：", -1));

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" (0为不随降) ");

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "    开盘时间：", -1));

const _hoisted_17 = /*#__PURE__*/_createTextVNode("  ");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("确认");

const _hoisted_19 = {
  class: "item-label"
};
const _hoisted_20 = {
  class: "item-qnum"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 期 没出降  ");

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " 连出降 ", -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#F56C6C"
  }
}, "注：此操作必须在官网上期结果后执行，如官网结果延迟将导致此操作延迟或失败", -1));

const _hoisted_24 = {
  class: "sub"
};

const _hoisted_25 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_26 = /*#__PURE__*/_createTextVNode("确认修改");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  const _component_el_radio_button = _resolveComponent("el-radio-button");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_pid,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active_pid = $event),
    size: "small",
    onChange: $options.change_group
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_group, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.name,
        label: item.pid
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_gid,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.active_gid = $event),
    size: "small",
    onChange: $options.change_game
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.id,
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.gname), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_9, "当前选择：" + _toDisplayString($data.checked_name), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_radio, {
    modelValue: $data.play_param.twosides_switch,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.play_param.twosides_switch = $event),
    label: "1"
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    modelValue: $data.play_param.twosides_switch,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.play_param.twosides_switch = $event),
    label: "2"
  }, {
    default: _withCtx(() => [_hoisted_13]),
    _: 1
  }, 8, ["modelValue"]), _hoisted_14, _createVNode(_component_el_input, {
    size: "small",
    style: {
      "width": "100px"
    },
    modelValue: $data.play_param.proportion,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.play_param.proportion = $event)
  }, null, 8, ["modelValue"]), _hoisted_15, _ctx.$store.state.userinfo.group_id == 2 && ($data.checked_name == '六合彩' || $data.checked_name == '香港六合彩' || $data.checked_name == '澳门六合彩' || $data.checked_name == '新澳门六合彩') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_16, _createVNode(_component_el_select, {
    modelValue: $data.play_param.check_time,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.play_param.check_time = $event),
    class: "m-2",
    placeholder: "Select",
    size: "small"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: "15点",
      value: "150"
    }), _createVNode(_component_el_option, {
      label: "15点30分",
      value: "155"
    }), _createVNode(_component_el_option, {
      label: "16点",
      value: "160"
    }), _createVNode(_component_el_option, {
      label: "16点30分",
      value: "165"
    }), _createVNode(_component_el_option, {
      label: "17点",
      value: "170"
    }), _createVNode(_component_el_option, {
      label: "17点30分",
      value: "175"
    }), _createVNode(_component_el_option, {
      label: "18点",
      value: "180"
    })]),
    _: 1
  }, 8, ["modelValue"]), _hoisted_17, _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: $options.sub_change
  }, {
    default: _withCtx(() => [_hoisted_18]),
    _: 1
  }, 8, ["onClick"])], 64)) : _createCommentVNode("", true)]), _createVNode(_component_el_row, null, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.play_param.twosides_proportion, (item, i) => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 6,
        key: item.index,
        style: {
          "margin": "3px 0"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("label", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(i + 1), 1), _hoisted_21]), _createVNode(_component_el_input, {
          size: "small",
          style: {
            "width": "40px"
          },
          modelValue: item[0],
          "onUpdate:modelValue": $event => item[0] = $event
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _hoisted_22, _createVNode(_component_el_input, {
          size: "small",
          style: {
            "width": "40px"
          },
          modelValue: item[1],
          "onUpdate:modelValue": $event => item[1] = $event
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), _hoisted_23, _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_button, {
    size: "small",
    type: "info",
    plain: "",
    onClick: _cache[6] || (_cache[6] = $event => $options.reset())
  }, {
    default: _withCtx(() => [_hoisted_25]),
    _: 1
  }), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_change
  }, {
    default: _withCtx(() => [_hoisted_26]),
    _: 1
  }, 8, ["onClick"])])])])]);
}